export const isNull = (x: unknown): x is null => x === null;
